module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "input": function($event) {
        return _vm.updateFlagsIfEventEdit()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "margin-left": "0",
      "padding": "0 2rem"
    }
  }, [_c('checkbox', {
    staticClass: "my-2",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.priceIncludeTaxesChanged
    },
    model: {
      value: (_vm.prices[0].isTaxIncludedInPrice),
      callback: function($$v) {
        _vm.$set(_vm.prices[0], "isTaxIncludedInPrice", $$v)
      },
      expression: "prices[0].isTaxIncludedInPrice"
    }
  }, [_c('span', {
    staticClass: "normal"
  }, [_vm._v("\n                            Price include taxes.\n                        ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mb-4",
    staticStyle: {
      "padding": "0",
      "margin-left": "0",
      "margin-right": "0"
    }
  }, [_c('div', {
    staticClass: "col-sm-4",
    class: _vm.isPriceTypeDisabled ? 'mb-1' : 'mb-3'
  }, [(_vm.types) ? _c('v-select', {
    class: {
      'notAllowed': _vm.isPriceTypeDisabled || _vm.disabled
    },
    attrs: {
      "options": _vm.types,
      "label": "description",
      "placeholder": "- Select type -",
      "disabled": _vm.disabled || _vm.isPriceTypeDisabled
    },
    on: {
      "input": function($event) {
        return _vm.updateType(_vm.selectedPrincingType)
      }
    },
    model: {
      value: (_vm.selectedPrincingType),
      callback: function($$v) {
        _vm.selectedPrincingType = $$v
      },
      expression: "selectedPrincingType"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.isPriceTypeDisabled) ? _c('div', {
    staticClass: "ml-3 mb-3"
  }, [(_vm.priceType === 'event') ? _c('span', {
    staticClass: "fs-small color-1"
  }, [_vm._v("Ticket type can only be edited in the product")]) : _vm._e(), _vm._v(" "), (_vm.priceType === 'product') ? _c('span', {
    staticClass: "fs-small color-1"
  }, [_vm._v("This schedule already has reservations. To change the Ticket Type, please cancel all reservations first.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedPrincingType && _vm.selectedPrincingType.id === _vm.PricingTypes.PerOrder) ? _c('div', {
    staticClass: "col-sm-12 mt-3",
    staticStyle: {
      "background": "#ffffff",
      "border-top": "1px solid #DBDFE2"
    }
  }, [_c('div', {
    staticClass: "row pt-3"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Tax")]), _vm._v(" "), (_vm.prices[0].productGenderPriceComponents && _vm.prices[0].productGenderPriceComponents.length > 0) ? _c('input', {
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.customPerPersonTaxes(_vm.prices[0].productGenderPriceComponents)
    }
  }) : (_vm.taxes) ? _c('v-select', {
    attrs: {
      "options": _vm.taxes,
      "label": "description",
      "placeholder": "- Select tax -",
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        return _vm.updateTaxType(_vm.prices[0], _vm.prices[0].vatTypeHelper)
      }
    },
    model: {
      value: (_vm.prices[0].vatTypeHelper),
      callback: function($$v) {
        _vm.$set(_vm.prices[0], "vatTypeHelper", $$v)
      },
      expression: "prices[0].vatTypeHelper"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.perOrderReferenceGenderPrice) ? _c('div', {}, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Price")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [(_vm.perOrderReferenceGenderPrice.productGenderPriceComponents && _vm.perOrderReferenceGenderPrice.productGenderPriceComponents.length > 0) ? _c('div', [(_vm.perOrderReferenceGenderPrice.componentRuleType == 0) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    staticStyle: {
      "width": "6rem"
    },
    attrs: {
      "type": "text",
      "disabled": _vm.perOrderReferenceGenderPrice.componentRuleType == 0 || _vm.disabled
    },
    domProps: {
      "value": _vm.customPerPersonTotal(_vm.perOrderReferenceGenderPrice.productGenderPriceComponents) + ' €'
    }
  })]) : _c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prices[0].value),
      expression: "prices[0].value"
    }],
    staticClass: "glued-right",
    staticStyle: {
      "width": "6rem"
    },
    attrs: {
      "type": "number",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.prices[0].value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prices[0], "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left"
  }, [_vm._v("€")])])]) : _c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prices[0].value),
      expression: "prices[0].value"
    }],
    staticClass: "glued-right",
    staticStyle: {
      "width": "4rem"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "number"
    },
    domProps: {
      "value": (_vm.prices[0].value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prices[0], "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left"
  }, [_vm._v("€")])]), _vm._v(" "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Edit'),
      expression: "'Edit'"
    }],
    staticClass: "fas fa-calculator fs-large medium ml-3",
    class: {
      'pointer': !_vm.disabled,
      'notAllowed': _vm.disabled,
      'dark': _vm.hasDecomposedPrices
    },
    on: {
      "click": function($event) {
        return _vm.openEditPrice(_vm.perOrderReferenceGenderPrice)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 mt-3"
  }, [_c('div', {
    staticClass: "pricesRowHolder"
  }, _vm._l((_vm.prices), function(pricePerPerson, index) {
    return _c('div', {
      key: index,
      staticClass: "mt-2 mb-3 pb-3 border-bottom-medium"
    }, [(pricePerPerson.isExcludedFromBilling) ? _c('div', [_c('PriceManagerRow', {
      attrs: {
        "disabled": _vm.disabled,
        "pricePerPerson": pricePerPerson,
        "pricePerOrder": true,
        "audienceTypes": _vm.genderPricesAvailableOptions,
        "prices": _vm.prices,
        "editingEvent": _vm.isEventEditMode
      },
      on: {
        "delete": function($event) {
          return _vm.deletePrincingType(index)
        },
        "updatedCustomInput": function($event) {
          return _vm.validateCustomNames()
        }
      }
    })], 1) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-sm-12 pb-3"
  }, [_c('div', {
    staticClass: "add d-flex align-items-center fs-small bold",
    class: {
      'pointer': !_vm.disabled,
      'notAllowed': _vm.disabled
    },
    on: {
      "click": _vm.addRow
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1"
  }), _vm._v(" Add price category\n                                    ")]), _vm._v(" "), (!_vm.isPerOrderAudienceValid) ? _c('div', {
    staticClass: "mt-2"
  }, [_c('span', {
    staticClass: "fs-small error"
  }, [_vm._v("At least one price category is required when using Per Order ticket type.")])]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (_vm.selectedPrincingType && _vm.selectedPrincingType.id === _vm.PricingTypes.PerGroup) ? _c('div', {
    staticClass: "col-sm-12 py-3",
    staticStyle: {
      "background": "#ffffff",
      "border-top": "1px solid #DBDFE2"
    }
  }, [_c('PricePerGroup', {
    attrs: {
      "disabled": _vm.disabled,
      "prices": _vm.prices,
      "hasDecomposedPrices": _vm.hasDecomposedPrices,
      "priceGroup": _vm.audienceTypeGroups,
      "group": _vm.group,
      "editingEvent": _vm.isEventEditMode
    },
    on: {
      "validatePriceGroupDecomposition": _vm.hasPriceGroupDecompositionError
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.audienceTypeGroups), function(priceGroup, index) {
    return (_vm.selectedPrincingType.id !== _vm.PricingTypes.PerGroup) ? _c('div', {
      key: index,
      staticClass: "row pt-2",
      class: {
        'price-group-wrapper': _vm.selectedPrincingType && _vm.selectedPrincingType.id !== _vm.PricingTypes.PerGroup
      }
    }, [(priceGroup.groupName != null || priceGroup.groupName != undefined) ? _c('div', {
      staticClass: "price-group-item col-sm-12"
    }, [(_vm.selectedPrincingType && _vm.selectedPrincingType.id === _vm.PricingTypes.PerPerson && priceGroup.groupName != null) ? _c('div', {
      staticClass: "price-group-item-header"
    }, [_c('div', {
      staticClass: "col-sm-12 pt-3 pb-3",
      class: {
        'pointer': !_vm.disabled,
        'notAllowed': _vm.disabled
      }
    }, [_c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ('Remove'),
        expression: "'Remove'"
      }],
      staticClass: "float-right ico-delete fs-large medium pointer removeSchedule",
      on: {
        "click": function($event) {
          return _vm.removeGroupOfPrices(priceGroup)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "full"
    }, [_vm._v("Group Name")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (priceGroup.groupName),
        expression: "priceGroup.groupName"
      }],
      class: {
        'error-field': priceGroup.repeatedName
      },
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "disabled": _vm.disabled,
        "placeholder": "Custom Price Group"
      },
      domProps: {
        "value": (priceGroup.groupName)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(priceGroup, "groupName", $event.target.value)
        }, function($event) {
          return _vm.changePricesAudienceTypeGroupNames(priceGroup, index)
        }]
      }
    }), _vm._v(" "), (!_vm.disabled && _vm.selectedPrincingType && _vm.selectedPrincingType.id === _vm.PricingTypes.PerPerson) ? _c('span', [(priceGroup.repeatedName) ? _c('div', {
      staticClass: "error"
    }, [_c('span', [_vm._v("The group name should be unique")])]) : (priceGroup.isEmptyName) ? _c('div', {
      staticClass: "error"
    }, [_c('span', [_vm._v("You must add a group name")])]) : _vm._e()]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedPrincingType && _vm.selectedPrincingType.id === _vm.PricingTypes.PerPerson) ? _c('PriceGroup', {
      attrs: {
        "currentGroupNameProp": priceGroup.groupName,
        "priceGroup": priceGroup,
        "audienceTypeGroups": _vm.audienceTypeGroups,
        "value": _vm.value,
        "disabled": _vm.disabled || priceGroup.repeatedName,
        "editingEvent": _vm.isEventEditMode,
        "backupedPricingType": _vm.backupedPricingType,
        "group": _vm.group,
        "selectedPrincingType": _vm.selectedPrincingType
      },
      on: {
        "deletepg": function($event) {
          return _vm.deletePrincingTypePG($event)
        },
        "updatedCustomInput": function($event) {
          return _vm.validateCustomNames()
        }
      }
    }) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), (_vm.selectedPrincingType && _vm.selectedPrincingType.id === _vm.PricingTypes.PerPerson) ? _c('div', {
    staticClass: "pt-3",
    staticStyle: {
      "border-top": "1px solid #dbdfe2"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "add d-flex align-items-center fs-small bold",
    class: {
      'pointer': !_vm.disabled,
      'notAllowed': _vm.disabled
    },
    on: {
      "click": _vm.addNewCustomPriceGroup
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1"
  }), _vm._v(" Add new Custom Price Group\n                        ")])])]) : _vm._e()], 2)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4eb697fe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eb697fe"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/components/PricingManager.vue
// module id = 1486
// module chunks = 0